import { Component } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { EmailService } from "../email.service";
import { SharedDataService } from "../../shared-data.service";
import { Subject } from "rxjs";
import { FormsModule } from "@angular/forms";
import { HotToastService } from "@ngneat/hot-toast";

@Component({
  selector: "app-imap-config",
  templateUrl: "./imap-config.component.html",
  styleUrls: ["./imap-config.component.scss"],
  imports: [FormsModule],
})
export class ImapConfigComponent {
  loading = false;

  imapPassword: string;
  email: string;
  allowed: boolean = false;
  onClose = new Subject();

  constructor(
    public bsModalService: BsModalService,
    public bsModalRef: BsModalRef,
    private emailService: EmailService,
    private sharedDataService: SharedDataService,
    private toastr: HotToastService,
  ) {}

  ngOnInit() {
    this.email = this.sharedDataService.user.email;
  }

  verifyLoginInformation() {
    this.loading = true;
    this.emailService
      .verifyLoginInformation(this.email, this.imapPassword)
      .subscribe((data: any) => {
        console.log(data);
        this.allowed = data.allowed;
        this.loading = false;

        if (this.allowed == false) {
          this.toastr.error("Invalid credentials. Please try again.");
        } else {
          this.createAccount();
        }
      });
  }

  createAccount() {
    this.loading = true;
    this.emailService.createAccount(this.email, this.imapPassword).subscribe(
      (data: any) => {
        console.log("createAccount", data);
        this.loading = false;
        this.onClose.next(data.state);
        this.bsModalRef.hide();
      },
      (err) => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }
}
